export type ThemeMode = 'light' | 'dark' | 'auto';

export function readThemeMode(): ThemeMode {
  try {
    const saved = localStorage.getItem('themeMode');
    return saved === 'light' || saved === 'dark' || saved === 'auto' ? saved : 'auto';
  } catch {
    return 'auto';
  }
}

export function persistThemeMode(mode: ThemeMode): void {
  document.documentElement.dataset.themeMode = mode;
  try {
    localStorage.setItem('themeMode', mode);
  } catch {
    // The theme still works when this browser cannot persist preferences.
  }
}
